import { FC } from "react";

interface LogoProps {
  className?: string;
}

const Logo: FC<LogoProps> = ({ className = "" }) => {
  return (
    <img
      src="/assets/images/conference/FMI/logo_fmi.jpg"
      alt="Conference Logo"
      className={`${className || `max-h-[60px]`}`}
    />
  );
};

export default Logo;